










































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyList from "@/mixins/list";
@Component
export default class extends Mixins(MyList) {
  @Prop() userId!: number;
  dispatchType: string = "users/contact";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "名称", dataIndex: "remark" },
    { title: "手机号", dataIndex: "mobile" },
    { title: "时间", dataIndex: "created_time" }
  ];

  mounted() {
    // console.log("mounted1");
    this.loadData(
      {
        user_id: this.userId
      },
      false
    );
  }
}
